import {
  GLOBAL_STEP_ORDER,
  WORKFLOW_CONFIG,
  MAIN_PROCESS_STEPS,
  normalizeWorkflowType,
} from '../constants/flowConfig';

/**
 * @param {string} fromStep
 * @param {string} toStep
 * @returns {boolean}
 */
export function isBackwardStepNavigation(fromStep, toStep) {
  const fromIdx = GLOBAL_STEP_ORDER.indexOf(fromStep);
  const toIdx = GLOBAL_STEP_ORDER.indexOf(toStep);
  return fromIdx > toIdx && toIdx >= 0;
}

/**
 * @param {string} currentWorkflow
 * @param {string} currentStep
 * @returns {string | null}
 */
export function resolvePreviousStep(currentWorkflow, currentStep) {
  const config = WORKFLOW_CONFIG[normalizeWorkflowType(currentWorkflow, currentStep)];
  if (!config) return null;

  const currentIndex = config.steps.indexOf(currentStep);

  if (currentStep === MAIN_PROCESS_STEPS.ALIGNMENT && currentIndex < 0) {
    return MAIN_PROCESS_STEPS.THICKNESS;
  }
  if (currentIndex > 0) return config.steps[currentIndex - 1];
  if (config.previousWorkflow) return config.previousWorkflow.step;
  return null;
}

/**
 * @param {string} currentStep
 * @param {string} targetStep
 * @returns {string}
 */
export function getBackwardDiscardMessage(currentStep, targetStep) {
  const fromIdx = GLOBAL_STEP_ORDER.indexOf(currentStep);
  const toIdx = GLOBAL_STEP_ORDER.indexOf(targetStep);
  const stepsBack = fromIdx - toIdx;

  if (stepsBack <= 1) {
    return 'Changes made in the current step will be lost. Go back and discard them?';
  }

  return 'Changes made in the current step and all later steps will be lost. Go back and discard them?';
}
